module.exports = __webpack_public_path__ + "img/w8-b2.e973c93a.jpg";